import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course04 from "../../../course/course-04/course";
import lesson0402 from "../../../lesson/course-04/lesson-02/lesson";
import lesson0407 from "../../../lesson/course-04/lesson-07/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "0f7baad3-8531-41dc-b5cb-4e85c9786d06",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0402),
    lesson: lesson0402,
  },
  {
    id: "406cbdbe-22cc-44c6-baa6-7af804436e89",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0407),
    lesson: lesson0407,
  },
];

export default lessonLinks;
